module.exports = __webpack_public_path__ + "img/empty.96c2542d.png";